import { render, staticRenderFns } from "./MoleculeContentNodeBlockLink.vue?vue&type=template&id=51c3361e&"
import script from "./MoleculeContentNodeBlockLink.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentNodeBlockLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports